// File: ManageBilling.jsx

import React from 'react';
import { getBillingApiUrl } from '../../config/ApiConfig';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51QZz55Dasl4Ek9fMi1GBDxyP4xWVK8psazWpNumMWQPve8Wspit2CbQFaonG49GkjO4RAsHk320oE9o6I23Y8kPE00TNeDQZRZ'); // Replace with your Stripe publishable key

const ManageBilling = ({ className }) => {
  const handleBilling = async () => {
    try {
      const stripe = await stripePromise;
      let billingApiUrl = getBillingApiUrl();
      console.log("Original Billing API URL:", billingApiUrl);

      billingApiUrl = billingApiUrl.replace(/\/+$/, '');
      console.log("Sanitized Billing API URL:", billingApiUrl);

      const response = await fetch(`${billingApiUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Origin': 'http://localhost:3000',
        },
        body: JSON.stringify({
          name: 'Test Product',
          price: 9.99,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const session = await response.json();
      const result = await stripe.redirectToCheckout({ sessionId: session.id });

      if (result.error) {
        console.error("Stripe Checkout Error:", result.error.message);
      }
    } catch (error) {
      console.error("Billing Error:", error.message);
      alert("Error with billing. Please try again later.");
    }
  };
// this is a test. 
  return (
    <button className={className} onClick={handleBilling}>
      Manage Billing
    </button>
  );
};

export default ManageBilling;
